import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported, Messaging } from 'firebase/messaging';

export const VAPID_KEY = 'BEZlAhSAr6v2FAgbwB2QyZIiFcPi1zhV-UTwU7KgVr5EGfJ6cQonN5W3keFPhnmQ5PpQkAK5aiVhkEqKgNKJ78c';

const firebaseConfig = {
    apiKey: "AIzaSyAEocxXbc38MAazXeUU7ZfQmxsPSKjThF4",
    authDomain: "ateshstudio.firebaseapp.com",
    projectId: "ateshstudio",
    storageBucket: "ateshstudio.firebasestorage.app",
    messagingSenderId: "1033387706524",
    appId: "1:1033387706524:web:a52479b1f55dd6ade90559",
    measurementId: "G-BB6ZP3STY2"
};

const app = initializeApp(firebaseConfig);

// messaging может быть null если браузер не поддерживает FCM (HTTP, старый Safari и т.д.)
export let messaging: Messaging | null = null;

export const messagingReady: Promise<Messaging | null> = isSupported().then((supported) => {
    if (supported) {
        messaging = getMessaging(app);
        return messaging;
    }
    return null;
});
